// extracted by css-extract-rspack-plugin
export default {"wrapper":"_bf5fb090","disableProjectsOverlay":"_e4f8480b"};